import React, { useState, useReducer, useEffect, useCallback, useMemo } from 'react'
import { Menu, Loader, Button, Dimmer, Form, Modal, Table, Dropdown, Label, Pagination } from 'semantic-ui-react'
import APIService from '../../Services/API/APIService';
import CreateOrder from './CreateOrder';
import { sortReducer } from "../../utils/SortReducer";
import numeral from 'numeral';
import AuditTrails from './AuditTrails';
import dayjs from 'dayjs';


const Resturant = () => {

    const [loading, setLoading] = useState(false)
    const [searchPhrase, setSearchPhrase] = useState(null);
    const [orderModalState, toggleOrderModal] = useState(null);
    const [auditModalState, toggleAuditModal] = useState(false);
    const [selectedAudit, setSelectedAudit] = useState(null);
    const [state, dispatch] = useReducer(sortReducer, {
        column: null,
        data: null,
        direction: null,
    });
    const { data } = state
    const [offset, setOffset] = useState(0);
    const [limit] = useState(50);
    const [rowCount, setRowCount] = useState(0);

    let query = useMemo(() => {
        return {
            offset: offset,
            limit: limit,
        }
    }, [limit, offset])
    const fetchData = useCallback(async (isSubscribed) => {
        try {
            setLoading(true);

            let result = await APIService.getData('/guest-house/getAllOrders', {
                ...query
            })

            if (isSubscribed) {
                dispatch({
                    type: "",
                    payload: result.orders,
                });
                setRowCount(result.count)
            }
            setLoading(false);
        } catch (error) {
            setLoading(false);
        }

    }, [query])

    useEffect(() => {
        let isSubscribed = true
        fetchData(isSubscribed);
   return () => (isSubscribed = false)
    }, [offset, orderModalState, fetchData]);

    const checkPayment = async (item) => {
        try {

            setLoading(true);
            let response = await APIService.postData(
                `/checkout/checkPayment`,
                { GuestHousePaymentId: item.GuestHousePaymentId, mode: 'checkin' }
            );
            var win = window.open(response?.location, "_blank");
            win.focus();

            setLoading(false);

        } catch (error) {
            console.log("error", error);
            setLoading(false);
        }
    };

    const _searchChanged = (e) => {
        setSearchPhrase(e.target.value);
    };
    const _search = async () => {
        setLoading(true);
        try {

            if (searchPhrase) {
                await APIService.getData(`/order/search/${searchPhrase}`);
            }
            setLoading(false);

        } catch (error) {
            console.log("error", error);
            setLoading(false);
        }
    };

    const openAuditModal = async (audit) => {
        try {
            setSelectedAudit({ orderId: audit.orderId });
            toggleAuditModal(true);
        } catch (error) {
            console.log("error", error);
        }
    };

    const openOrderModal = () => {
        try {
            toggleOrderModal(true);
        } catch (error) {
            console.log("error", error);
        }
    };

    let counter = 0

    let bookingItems = data?.map((item,index) => (

        <Table.Row key={index}>

            <Table.Cell>   {counter = counter + 1} </Table.Cell>
            <Table.Cell>   {item.orderId} </Table.Cell>
            <Table.Cell>
                {item.name}

            </Table.Cell>
            <Table.Cell>
                ₦
                {
                    numeral(item.food).format("0,0")
                }

            </Table.Cell>
            <Table.Cell>
                ₦
                {
                    numeral(item.beverage).format("0,0")
                }

            </Table.Cell>
            <Table.Cell>

                ₦
                {
                    numeral(item.laundry).format("0,0")
                }

            </Table.Cell>
            <Table.Cell>

                ₦
                {
                    numeral(item.snack).format("0,0")
                }

            </Table.Cell>
            <Table.Cell>

                ₦
                {
                    numeral(item.chinchin).format("0,0")
                }
            </Table.Cell>
            <Table.Cell>
                ₦
                {
                    numeral(item.price).format("0,0")
                }
            </Table.Cell>
            <Table.Cell>
                {item.description}
            </Table.Cell>
            <Table.Cell>{dayjs(item.date).format("DD-MMM-YYYY")}</Table.Cell>

            <Table.Cell>      <Label
                onClick={() => checkPayment(item)}
                color={
                    item.paymentMode === "POS"
                        ? "teal"
                        : item.paymentMode === "DIRECT_TRANSFER"
                            ? "violet"
                            : item.paymentMode === "CASH"
                                ? "olive"
                                : "brown"
                }
            >
                {item?.paymentMode === "DIRECT_TRANSFER" ? "TRANSFER" : item?.paymentMode || "N/A"}
            </Label></Table.Cell>


            <Table.Cell>


                {item.paymentMode === 'DIRECT_TRANSFER' ?
                    (
                        <Label color={
                            item?.verified === true ? "teal" : 'red'
                        }>
                            {item?.verified === true ? "Yes" : 'No'}
                        </Label>
                    )
                    :

                    (<Label color="brown">
                        N/A
                    </Label>)


                }

            </Table.Cell>
            <Table.Cell>
                <Dropdown icon="ellipsis vertical" fluid floating pointing="bottom right">
                    <Dropdown.Menu>

                        <Dropdown.Item
                            icon="tasks"
                            text="View Audit Trails"
                            onClick={() => openAuditModal(item)}
                        />


                    </Dropdown.Menu>
                </Dropdown>
            </Table.Cell>
        </Table.Row>
    ))

    return (
        <div>


            {loading && (
                <Dimmer active inverted>
                    <Loader />
                </Dimmer>
            )}


            <Menu secondary stackable>
                <Menu.Item fitted>
                    <Button onClick={() => openOrderModal()} style={{ backgroundColor: '#26f09e', color: '#000000' }}>Create Order</Button>
                </Menu.Item>

                <Menu.Menu position="right">
                    <Menu.Item>
                        <Form>
                            <Form.Input
                                placeholder="Name, Email or Phone"
                                icon="search"
                                onChange={_searchChanged}
                                action={{
                                    onClick: _search,
                                    color: 'teal'
                                }}
                                disabled
                            />
                        </Form>
                    </Menu.Item>
                </Menu.Menu>
            </Menu>

            {data && (
                <Table striped stackable>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell>S/N</Table.HeaderCell>

                            <Table.HeaderCell>OrderId</Table.HeaderCell>

                            <Table.HeaderCell>Name</Table.HeaderCell>
                            <Table.HeaderCell>Food</Table.HeaderCell>
                            <Table.HeaderCell>Beverage</Table.HeaderCell>
                            <Table.HeaderCell>Laundry</Table.HeaderCell>
                            <Table.HeaderCell>Snack</Table.HeaderCell>
                            <Table.HeaderCell>Chin-Chin</Table.HeaderCell>
                            <Table.HeaderCell>Price</Table.HeaderCell>
                            <Table.HeaderCell>Description</Table.HeaderCell>
                            <Table.HeaderCell>Date</Table.HeaderCell>
                            <Table.HeaderCell>Payment Mode</Table.HeaderCell>
                            <Table.HeaderCell>Verified </Table.HeaderCell>

                            <Table.HeaderCell></Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>

                    <Table.Body>{bookingItems}</Table.Body>
                </Table>
            )}
            <Pagination
                defaultActivePage={1}
                totalPages={Math.ceil(rowCount / limit)}
                onPageChange={(e, { activePage }) =>
                    setOffset(1 + (activePage - 1) * limit)
                }
            />
            <Modal
                size="small"
                open={orderModalState}
                onClose={() => toggleOrderModal(false)}
                closeIcon
            >
                <Modal.Header>Create Order</Modal.Header>
                <Modal.Content>
                    <CreateOrder toggleOrderModal={toggleOrderModal} />
                </Modal.Content>
            </Modal>

            <Modal
                size="small"
                open={auditModalState}
                onClose={() => toggleAuditModal(false)}
                closeIcon
            >
                <Modal.Header>Audit Trails</Modal.Header>
                <Modal.Content>
                    <AuditTrails audit={selectedAudit} />
                </Modal.Content>
            </Modal>


        </div>
    )
}

export default Resturant